import React, { useState, useEffect, useReducer } from "react";
import DialogContent from "@mui/material/DialogContent";
import {
    TextField,
    Switch,
    Tooltip,
    Grid,
    MenuItem,
    Stack,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import currentUserToken from "CurrentUserToken";
import { get } from "aws-amplify/api";
import { I18n } from "aws-amplify/utils";
import { Typography } from "@mui/material";

const reducer = (lastState, action) => {
    switch (action.type) {
      case "DATA_RECEIVED":
        const accountAssets = action.value;
        if (Array.isArray(accountAssets)) {
            return { ...lastState, accountAssets: accountAssets, fetched: true };
        }
        return lastState;
      default:
        return lastState;
    }
};

function EditMapStep(props) {
    const [state, dispatch] = useReducer(reducer, {
        accountAssets: [],
        fetched: false,
    });
    const [delayError, setDelayError] = useState(false);
    const [isLocked, setIsLocked] = useState(props.mainFormData.flag);
    const validEmail = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]{1,}[.][a-zA-Z]{2,}$');
    const [selectedAsset, setSelectedAsset] = useState("");
    const [options, setOptions] = useState([]);

    const handleChange = (event) => {
        if (event.target.name === "tlm_asset_id") {
            setSelectedAsset(event.target.value);
        }
        props.handleMainFormData(event.target.name, event.target.value);
    };

    useEffect(() => {
        const tlmGetAccountAssets = async (accountID) => {
        try {
            const restOperation = get({
            apiName: "TelemonitoringAPI",
            path: "/accountNumber/asset",
            options: {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${await currentUserToken()}`,
            },
            queryParams: {
                account_id: accountID,
                record_type_id: "0126N000000ChTeQAK",
            },
            },
            });

            const { body } = await restOperation.response;
            const response = await body.json();
            setSelectedAsset(response.find((asset) => asset.id === props.mainFormData.tlm_asset_id).fsl_name_and_serial_number);
            dispatch({ type: "DATA_RECEIVED", value: response });
        } catch (error) {
            console.error("Error fetching tlm assets:", error);
            throw error;
        }
        };
        tlmGetAccountAssets(props.mainFormData.account_id);
    }, []);

    useEffect(() => {
        if (props.mainFormData.rule === "email") {
            props.handleMainFormData("email_address", props.mainFormData.search_pattern);
        }else if (props.mainFormData.rule === "subject") {
            props.handleMainFormData("word_key", props.mainFormData.search_pattern);
        }else if (props.mainFormData.rule === null) {
            props.handleMainFormData("email_address", props.mainFormData.search_pattern);
        }
    }, []);

    return (
        <DialogContent>
        <FormControl fullWidth margin="normal" className="custom-form-control">
            <TextField
            label={I18n.get("Account Number")}
            value={props.mainFormData.account_number}
            fullWidth
            margin="normal"
            name="account_number"
            InputProps={{
                readOnly: true,
            }}
            required
            disabled
            className="custom-text-field"
            />
            {/* <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText> */}
        </FormControl>

        {/* This select is for the telemonitoing asset */}
        <FormControl fullWidth margin="normal" className="custom-form-control">
          <InputLabel>{I18n.get("Telemonitoring Asset")}</InputLabel>
          <Select
            //value={props.mainFormData.tlm_asset_id}
            value={selectedAsset}
            onChange={handleChange}
            name="tlm_asset_id"
            label={I18n.get("Telemonitoring Asset")}
            required
          >
            {state.accountAssets.map((asset) => (
                <MenuItem value={asset.fsl_name_and_serial_number} key={asset.fsl_name_and_serial_number} name={asset.fsl_name_and_serial_number}>
                    {asset.fsl_name_and_serial_number}
                </MenuItem>
            ))}
          </Select>
          <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
        </FormControl>

        <FormControl fullWidth margin="normal" className="custom-form-control">
          <InputLabel>{I18n.get("Rule")}</InputLabel>
          <Select
            value={props.mainFormData.rule || ""}
            onChange={handleChange}
            name="rule"
            label={I18n.get("Rule")}
            required
          >
            <MenuItem value="email" key="email" name="email">
               {I18n.get("Email")}
            </MenuItem>
            <MenuItem value="subject" key="subject" name="subject">
                {I18n.get("Subject")}
            </MenuItem>
          </Select>
          <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
        </FormControl>

        { props.mainFormData.rule === "email" && props.mainFormData.unrec_email ? (
            <FormControl fullWidth margin="normal" className="custom-form-control">
                <TextField
                label={I18n.get("Email Address")}
                value={props.mainFormData.email_address}
                fullWidth
                margin="normal"
                name="email_address"
                InputProps={{
                    readOnly: true,
                }}
                required
                disabled
                className="custom-text-field"
                />
                <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
            </FormControl>
            ) : props.mainFormData.rule === "subject" ? (
                <FormControl fullWidth margin="normal" className="custom-form-control">
                <TextField
                    label={I18n.get("Word key")}
                    value={props.mainFormData.word_key}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    name="word_key"
                    required
                    className="custom-text-field"
                /> 
                <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
                </FormControl>
            ) : props.mainFormData.rule === "email" ? (
                <FormControl fullWidth margin="normal" className="custom-form-control">
                <TextField
                    label={I18n.get("Email Address")}
                    value={props.mainFormData.email_address}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    name="email_address"
                    required
                    className="custom-text-field"
                /> 
                {validEmail.test(props.mainFormData.email_address) ? 
                "" : <FormHelperText>{I18n.get("Invalid email address")}</FormHelperText>

                }
                <FormHelperText>{I18n.get("Mandatory field")}</FormHelperText>
                </FormControl>
            ) : ""
        }
        
        <FormControl fullWidth margin="normal" className="custom-form-control">
            <TextField
                required
                fullWidth
                label={I18n.get("Email Delay")} // Traduzione
                type="number"
                inputProps={{
                    min: 0,
                    max: 24,
                    onKeyDown: (e) => {
                    if (e.key !== "ArrowUp" && e.key !== "ArrowDown") {
                        e.preventDefault();
                    }
                    },
                }}
                value={props.mainFormData.delay}
                name={"delay"}
                onChange={handleChange}
                error={delayError}
                helperText={delayError ? I18n.get("Email delay is required") : ""} // Traduzione
                sx={{ mb: 2 }}
            />
        </FormControl>

        <FormControl fullWidth margin="normal" className="custom-form-control">
            <Typography variant="body2">
               { I18n.get("Create live signal email")}
            </Typography>
            <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <Tooltip title={isLocked ? "Unlock" : "Unlock"}>
                    <Typography variant="body2"> Off  </Typography>
                </Tooltip>
                <Switch
                    checked={isLocked}
                    onChange={() => {setIsLocked(!isLocked); props.handleMainFormData("flag", !isLocked)}}
                    color="primary"
                />
                <Tooltip title={isLocked ? "Lock" : "Lock"}>
                    <Typography variant="body2"> On </Typography>
                </Tooltip>
            </Stack>
        </FormControl>

        </DialogContent>
    );
}

export default EditMapStep;
